import client from '../httpClient';

const customerGetShareApi = (customerId, params) => {
  return client.get(`/customers/share/${String(customerId)}`, JSON.stringify(params));
};

export default customerGetShareApi;
